import React from 'react';

export default function ShieldIcon(props) {
  return (
    <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M6.99992 17.7501C6.809 17.6355 6.62159 17.5235 6.43775 17.4135C2.6094 15.1243 0.333252 13.7633 0.333252 10.2501V4.00008L6.99992 0.666748L13.6666 4.00008V10.2501C13.6666 13.7633 11.3904 15.1243 7.56209 17.4135C7.37825 17.5235 7.19083 17.6355 6.99992 17.7501ZM10.7403 13.2422C11.5811 12.4333 11.9999 11.6087 11.9999 10.2501V5.03014L6.99992 2.53014L1.99992 5.03014V10.2501C1.99992 11.6087 2.41872 12.4333 3.25954 13.2422C4.09896 14.0497 5.29279 14.7838 6.99992 15.8072C8.70705 14.7838 9.90087 14.0497 10.7403 13.2422Z" fill="#111111" />
    </svg>
  );
}
